/** Shared canvas number formatting — one policy for node + edge values.
 *
 *  Integers as-is; ≥100 one decimal; ≥1000 collapse to `k`; small fractions
 *  keep two decimals, trimmed (0.24 — not 0.2400000001, and not 0.2, which
 *  destroys probability-scale values). */
export function formatNum(n: number): string {
  const a = Math.abs(n);
  if (a >= 1000) return (n / 1000).toFixed(1) + 'k';
  if (Number.isInteger(n)) return String(n);
  if (a >= 100) return n.toFixed(1);
  return String(parseFloat(n.toFixed(2)));
}
